<div class="min-h-full px-8">
  <div
    class="relative grid grid-cols-1 gap-2 place-content-center justify-items-center min-h-screen text-center lg:grid-cols-2 lg:gap-6 lg:justify-normal"
  >
    <div class="absolute inset-x-0 top-11">
      <img
        src="assets/images/Logo_SegurosReservas.svg"
        class="w-[153px] lg:w-[201px]"
        alt=""
      />
    </div>
    <div class="lg:justify-self-end">
      <img
        src="assets/images/404_NotFound.svg"
        alt="404 Not Found"
        class="w-64 lg:w-[537px] mb-5 lg:mb-0"
      />
    </div>
    <div class="lg:justify-self-start lg:text-left">
      <!-- Mensaje principal -->
      <h2
        class="text-4xl mb-2 font-freightSansProBold text-tertiary-normal lg:text-7xl"
      >
        Oops,
      </h2>

      <!-- Mensaje de descripción -->
      <p
        class="text-lg text-primary-normal max-w-xs md:max-w-md font-freightSansProMedium lg:text-left lg:text-xl"
      >
        La página que estás buscando no está disponible.
      </p>
      <p
        class="mb-5 text-lg text-primary-normal max-w-xs md:max-w-md font-freightSansProMedium lg:text-left lg:text-xl"
      >
        Intenta buscando de nuevo o ve a la página de
        <a
          routerLink="/inicio"
          class="text-secondary-normal font-freightSansProBold"
          >Inicio</a
        >.
      </p>
      <!-- Botón de regreso al inicio -->
      <button
        routerLink="/inicio"
        class="px-4 py-1.5 border-2 h-14 w-[255px] border-primary-normal rounded-lg text-xl lg:text-xl text-primary-normal font-freightSansProBold hover:bg-primary-normal hover:text-white transition-all md:px-6 md:py-2"
      >
        Volver a Inicio
      </button>
    </div>
  </div>
</div>
